var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DynamicForm',{ref:"form",staticClass:"CteDetails__Form__Fields",attrs:{"model":_vm.form,"blueprint":_vm.blueprint()}})}
var staticRenderFns = []

export { render, staticRenderFns }